/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES, useIsUserLicensed } from "@bms/common";
import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

export const LicensedRoute = (props: RouteProps) => {
  const isUserLicensed = useIsUserLicensed();

  return (
    <Route {...props}>
      {!isUserLicensed && (
        <Redirect
          to={{
            pathname: ROUTES.BASE,
          }}
        />
      )}
    </Route>
  );
};
